import React from 'react';

// Uzbek traditional ornament SVG pattern component
export const UzbekOrnament = ({ className = "", color = "currentColor", size = 40 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 10 L60 25 L75 25 L65 40 L70 55 L50 45 L30 55 L35 40 L25 25 L40 25 Z"
      fill={color}
      opacity="0.8"
    />
    <circle cx="50" cy="50" r="8" fill={color} opacity="0.6" />
    <path
      d="M50 70 L55 80 L65 80 L58 87 L60 97 L50 92 L40 97 L42 87 L35 80 L45 80 Z"
      fill={color}
      opacity="0.4"
    />
  </svg>
);

export const OrnamentBorder = ({ className = "" }) => (
  <div className={`ornament-border ${className}`}>
    <svg width="100%" height="20" viewBox="0 0 200 20" preserveAspectRatio="none">
      <defs>
        <pattern id="uzbekPattern" x="0" y="0" width="40" height="20" patternUnits="userSpaceOnUse">
          <path d="M0 10 Q10 0 20 10 Q30 20 40 10" stroke="currentColor" fill="none" strokeWidth="2" />
          <circle cx="20" cy="10" r="3" fill="currentColor" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#uzbekPattern)" />
    </svg>
  </div>
);

export const FloatingOrnaments = () => (
  <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
    <div className="absolute top-20 left-10 opacity-5 animate-pulse">
      <UzbekOrnament size={120} color="#1e40af" />
    </div>
    <div className="absolute top-40 right-20 opacity-5 animate-pulse" style={{ animationDelay: '1s' }}>
      <UzbekOrnament size={80} color="#1e40af" />
    </div>
    <div className="absolute bottom-40 left-1/4 opacity-5 animate-pulse" style={{ animationDelay: '2s' }}>
      <UzbekOrnament size={100} color="#1e40af" />
    </div>
    <div className="absolute bottom-20 right-1/3 opacity-5 animate-pulse" style={{ animationDelay: '0.5s' }}>
      <UzbekOrnament size={60} color="#1e40af" />
    </div>
  </div>
);

export default UzbekOrnament;
